import type { UseFormSetError, FieldValues, Path } from "react-hook-form";

interface CoordinateValidationResult {
  latitude: number | null;
  longitude: number | null;
  isValid: boolean;
}

/**
 * 緯度・経度の文字列をパースしてバリデーションを行う
 * @param latitudeStr 緯度の文字列
 * @param longitudeStr 経度の文字列
 * @param setError React Hook FormのsetError関数
 * @returns パース結果とバリデーション結果
 */
export const validateCoordinates = <T extends FieldValues>(
  latitudeStr: string | undefined,
  longitudeStr: string | undefined,
  setError: UseFormSetError<T>
): CoordinateValidationResult => {
  const latitude = latitudeStr ? parseFloat(latitudeStr) : null;
  const longitude = longitudeStr ? parseFloat(longitudeStr) : null;

  let isValid = true;

  if (latitude !== null && isNaN(latitude)) {
    setError("requestLatitude" as Path<T>, {
      type: "manual",
      message: "有効な数値を入力してください",
    });
    isValid = false;
  }

  if (longitude !== null && isNaN(longitude)) {
    setError("requestLongitude" as Path<T>, {
      type: "manual",
      message: "有効な数値を入力してください",
    });
    isValid = false;
  }

  return { latitude, longitude, isValid };
};
